import { useState } from 'react';
import useCanManageBrandCatalogs from '../../../../../../../hooks/useCanManageBrandCatalogs';

interface UseCatalogGeneralInfoActionsParams {
  isReadOnly: boolean;
}

const useCatalogGeneralInfoActions = ({ isReadOnly }: UseCatalogGeneralInfoActionsParams) => {
  const canManageBrandCatalogs = useCanManageBrandCatalogs();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isBannersModalOpen, setIsBannersModalOpen] = useState(false);

  const closeMenu = () => setAnchorEl(null);

  const openBannersModal = () => {
    closeMenu();
    setIsBannersModalOpen(true);
  };

  return {
    canShowActions: canManageBrandCatalogs && !isReadOnly,
    anchorEl,
    isMenuOpen: Boolean(anchorEl),
    isBannersModalOpen,
    openMenu: setAnchorEl,
    closeMenu,
    openBannersModal,
    closeBannersModal: () => setIsBannersModalOpen(false),
  };
};

export default useCatalogGeneralInfoActions;
